import { Box, Typography } from '@mui/material';

function PortfolioItem(props) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        padding: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        transition: 'all 0.2s ease',
        flexDirection: { xs: 'column', sm: 'row' },
        textAlign: { xs: 'center', sm: 'left' },
        '&:hover': {
          borderColor: 'text.primary',
        },
      }}
    >
      <Box
        component="img"
        src={props.image}
        alt={`${props.title} logo`}
        sx={{
          width: { xs: 50, sm: 40 },
          height: { xs: 50, sm: 40 },
          borderRadius: '50%',
          flexShrink: 0,
        }}
      />

      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="h4"
          sx={{
            marginBottom: 0.25,
            fontWeight: 600,
            fontSize: { xs: '1rem', sm: '1.1rem' },
          }}
        >
          {props.title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.4,
            fontSize: '0.85rem',
          }}
        >
          {props.desc}
        </Typography>
      </Box>
    </Box>
  );
}

export default PortfolioItem;
